const quickFetch = () => {
  const chirpMatch = window.location.href.match(/[?]isChirp=(\w+)/);
  const isChirp = chirpMatch && chirpMatch[1] === 'true';
  // TODO: look into manually calling chirp requests early here without .early hook
  if (isChirp) return;
  if (!window.quickFetch) return;
  const urlMatch = window.location.href.match(/\/documents\/(\d+)\/view\/(\d+)\/?\?accessId=(\w+)/);
  if (!urlMatch) return;
  const portalId = urlMatch[1];
  const presentationId = urlMatch[2];
  const accessId = urlMatch[3];
  window.quickFetch.makeEarlyRequest('public-presentation', {
    url: window.quickFetch.getApiUrl(`/presentations/v2/public/portals/${portalId}/presentations/${presentationId}/${accessId}`, true),
    type: 'GET',
    contentType: 'application/json',
    dataType: 'json'
  });
  window.quickFetch.makeEarlyRequest('public-legal-consent', {
    url: window.quickFetch.getApiUrl(`/presentations/v1/gdpr/public/presentations/${presentationId}/viewer-form?portalId=${portalId}&accessId=${accessId}`, true),
    type: 'GET',
    dataType: 'json',
    timeout: 12000,
    withCredentials: true,
    extraHeaders: [{
      header: 'Accept',
      value: 'application/json, text/javascript, */*; q=0.01'
    }]
  });
};
quickFetch();